import React, { PropsWithChildren } from 'react';

type DefaultLayoutProps = PropsWithChildren<{}>;

export const DefaultLayout = ({ children }: DefaultLayoutProps) => {
  return <main className="w-full flex-1 pt-24 print:pt-0">{children}</main>;
};
